
import { Component, Vue } from 'vue-property-decorator';
import { BlockStore, CommonStore, FarmStore } from '@/store/modules';
import { Farm } from '@/store/models/farm';
import SvgIcon from '@/components/SvgIcon.vue';
import { Crop } from '@/store/models/block';
import { format } from 'quasar';
const { pad } = format;
@Component({
  components: {
    SvgIcon
  }
})
export default class CropList extends Vue {
  get crops() {
    return BlockStore.Crops;
  }

  farm: Farm | null = null;

  deleteDialog = false;

  logTab = 'stdout';

  enumParameters: Record<string, Record<string, string>> = {};

  loading = true;

  get dateList() {
    return CommonStore.CalendarDayList;
  }

  get tableColumn() {
    // This needs to be a getter in order to prevent table to be rendered before loading is complete
    // (filtering in the q-table tag doesn't work)
    return this.loading
      ? []
      : [
          {
            name: 'id',
            label: 'Id',
            field: (row: Crop) => row.id,
            sortable: true,
            align: 'left',
            style: 'width: 10px',
            headerStyle: 'width: 10px;'
          },
          {
            name: 'name',
            label: 'Name',
            field: (row: Crop) => row.cropTypeName,
            sortable: true,
            align: 'left'
          },
          {
            name: 'variety__name',
            label: 'Variety',
            field: (row: Crop) => row.varietyName,
            sortable: true,
            align: 'left'
          },
          {
            name: 'target_heat_unit',
            label: 'Target Heat Unit for Harvesting',
            field: (row: Crop) => row.targetHeatUnit,
            sortable: true,
            align: 'left'
          },
          {
            name: 'targetHeatUnitStoneHardening',
            label: 'Target Heat Unit for Stone-Hardening',
            field: (row: Crop) => row.targetHeatUnitStoneHardening,
            sortable: true,
            align: 'left',
            style: 'width: 50px',
            headerStyle: 'width: 50px'
          },
          {
            name: 'maximum_fruit_load',
            label: 'Maximum Fruit Load',
            field: (row: Crop) => row.maximumFruitLoad,
            sortable: true,
            align: 'left'
          },
          {
            name: 'head_base',
            label: 'Lower Heat Base',
            field: (row: Crop) => row.heatBase,
            sortable: true,
            align: 'left'
          },
          {
            name: 'head_base_upper',
            label: 'Upper Heat Base',
            field: (row: Crop) => row.heatBaseUpper,
            sortable: true,
            align: 'left'
          },
          {
            name: 'k',
            label: 'Mass coefficient (k)',
            field: (row: Crop) => row.k,
            sortable: true,
            align: 'left'
          },
          {
            name: 'weight',
            label: 'Fruit Weight (Kg)',
            field: (row: Crop) => row.weight,
            sortable: true,
            align: 'left'
          },
          {
            name: 'start_date',
            label: 'Start Date',
            field: (row: Crop) =>
              `${this.dateList[row.startMonth].shortName} - ${pad(String(row.startDay), 2)}`,
            sortable: true,
            align: 'left'
          },
          {
            name: 'end_date',
            label: 'End Date',
            field: (row: Crop) =>
              `${this.dateList[row.endMonth].shortName} - ${pad(String(row.endDay), 2)}`,
            sortable: true,
            align: 'left'
          },
          {
            name: 'harvest_date_calculation_method',
            label: 'Harvest Date Calculation',
            field: (row: Crop) => this.enumParameters?.harvest_date_calculation_method?.[row.harvestDateCalculationMethod] || row.harvestDateCalculationMethod,
            sortable: true,
            align: 'left'
          },
          {
            name: 'preferred_gdd_method',
            label: 'Preferred GDD method',
            field: (row: Crop) => this.enumParameters?.preferred_gdd_method?.[row.preferredGddMethod] || row.preferredGddMethod,
            sortable: true,
            align: 'left'
          },
          {
            name: 'harvest_days_offset',
            label: 'Harvest Days Offset',
            field: (row: Crop) => row.harvestDaysOffset,
            sortable: true,
            align: 'left'
          },
          {
            name: 'actions',
            label: 'Actions',
            align: 'right'
          }
        ];
  }

  initialPagination: {
    sortBy: string;
    descending: boolean;
    page: number;
    rowsPerPage: number;
  } = {
    sortBy: 'id',
    descending: true,
    page: 1,
    rowsPerPage: 10
  };

  async onDelete(farmId: number) {
    this.deleteDialog = false;
    if (farmId != 0) {
      FarmStore.deleteFarm(farmId);

      FarmStore.setAddEditFarm({} as Farm);
    }
  }

  deleteFarm(farm: Farm) {
    this.farm = farm;
    this.deleteDialog = true;
  }

  async created() {
    this.loading = true;
    await BlockStore.getAllCrops();

    // Fetch enum values
    try {
      const response = await fetch('/api/crops/crop_parameters/');
      if (response.ok) {
        const data = await response.json();
        this.enumParameters = data;
      }
      else {
        console.error('/api/crops/crop_parameters/');
      }
    }
    catch (error) {
      console.error('/api/crops/crop_parameters/:', error);
    }

    this.loading = false;
  }
}
